<template>
    <div class="content mt20 bgfff">
        <div class="bd clearfix">
            <div class="title">我的下载</div>
        </div>
        <div class="table-warp mt15">
            <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                <colgroup>
                    <col width="25%">
                    <col width="20%">
                    <col width="20%">
                    <col width="20%">
                    <col width="10%">
                </colgroup>
                <thead>
                    <tr>
                        <th>文件</th>
                        <th>创建时间</th>
                        <th>完成时间</th>
                        <th>下载进度</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in list" :key="index">
                        <td>{{item.fileName}}</td>
                        <td>{{item.addTime}}</td>
                        <td>{{item.finishTime === '' ? '--' : item.finishTime}} </td>
                        <td>
                            <div class="progress progress-striped fl">
                                <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" :style="{width:''+item.status+''}">
                                </div>
                            </div>
                            <span class="sr-only color-blue">{{item.status}}</span>
                        </td>
                        <td>
                            <div class="profile-btn" v-if="item.status === '100%'">
                                <a :href="item.downUrl" title="下载"><i class="icons download-icon"></i></a>
                                <a href="javascript:void(0);" @click="delDownload(index);" title="删除"><i class="icons icon-del"></i></a>
                            </div>
                            <span v-if="item.status != '100%'">--</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- 分页 -->
            <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
        </div>
        <!-- 删除提示 -->
        <Dialog ref="delTips" :callback="enterDel" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否确认删除？</p>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../components/dialog.vue';
import Page from '@/components/page'
export default {
    components: {Page,Dialog},
    data() {
        return {
            list:[],
            page:1,
            limit:20,
            delIndex:'',//操作的索引
            notFinished:[],
            timer:'',//定时获取下载进度
            totalCount:'',//总条数
        }
    },
    mounted() {
        let that = this;
        that.$nextTick(()=> {
           that.getMyDownload();
        })
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    created() {
		
    },
    methods: {
        getMyDownload (type) {
            let that = this;
            that.$parent.loadModal(true,'获取数据中...');
            that.$api.post('personal/downloadlist',{page:that.page,pagesize:that.limit},r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.list = r.data.list;
                    that.totalCount = r.data.total;
                    let notFinished = [];
                    for(let i of r.data.list){
                        if(i.status != '100%'){
                            notFinished.push(i.id);
                        }
                    }
                    that.notFinished = notFinished;
                    if(notFinished.length != 0){
                        that.timer = setInterval(() => {
                            that.getDownloadStatus();
                        }, 1000);
                    }
                })
            })
        },
        // 删除下载
        delDownload (index) {
            let that = this;
            let list = that.list;
            if(list.status != '100%'){
                that.$utils.alertText('下载任务完成后方可删除！');
                return;
            }
            that.refs.delTips.showMaskFun();
            that.delIndex = index;
        },
        // 确认删除
        enterDel () {
            let that = this;
            let id = that.list[that.delIndex].id;
            that.$parent.loadModal(true,'提交数据中...');
            that.$api.post('personal/deldownload',{id:that.id},r => {
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.getMyDownload();
                })
            })
        },
        // 获取下载进度
        getDownloadStatus () {
            let that = this;
            let notFinished = that.notFinished;
            if(notFinished.length === 0){
                clearInterval(that.timer);
                return;
            }
            that.$api.post('personal/downloadprogress',{id:notFinished},r => {
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    for(let i of data){
                        if(i.progress === 100){
                            let index = notFinished.indexOf(i.recordId);
                            notFinished.splice(index,1);
                        }
                        for(let j of that.list){
                            if(i.id === j.id){
                                j.status = i.progress;
                                j.finishTime = i.finishTime;
                                j.downUrl = i.url;
                            }
                        }
                    }
                })
            })
        },
        // 翻页
        getTableData () {
            clearInterval(that.timer);
            this.getMyDownload();
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/myDownload.vue